export const previewFileModalName = 'preview-file';
